
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/[...identity]",
      function () {
        return require("private-next-pages/activities/[...identity].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/[...identity]"])
      });
    }
  